import { WorkflowListResponseMessageSchema, WorkflowsSchema } from '../types';
import type { WorkflowDescriptor } from '../userResponse/agents';
import { logger } from '../utils/logger';

/**
 * Handle a WORKFLOW_LIST_RES message from the web SDK.
 *
 * The frontend sends each registered workflow component's descriptor (id,
 * name, description, whenToUse, propsSchema, defaultProps) so the backend
 * MainAgent can route prompts to them.
 */
export async function handleWorkflowListResponse(
	data: any,
	storeWorkflows: (workflows: WorkflowDescriptor[]) => void,
): Promise<void> {
	try {
		const parsed = WorkflowListResponseMessageSchema.parse(data);
		const { payload } = parsed;

		const workflowsList = payload.workflows;
		if (!workflowsList) {
			logger.error('Workflows list not found in WORKFLOW_LIST_RES payload');
			return;
		}

		const workflows = WorkflowsSchema.parse(workflowsList) as WorkflowDescriptor[];
		storeWorkflows(workflows);
		logger.info(`Stored ${workflows.length} workflow descriptor(s) from frontend`);
	} catch (error) {
		logger.error('Failed to handle workflow list response:', error);
	}
}
